module.exports = __webpack_public_path__ + "img/Die Sprachbruke.dad9227e.png";